<div class="overlay" *ngIf="loader"></div>
<div *ngIf="loader"
  class="fa fa-gear fa-spin"
  style="
    font-size: 72px;
    color: lightblue;
    left: 47%;
    top: 45%;
    position: absolute;
    z-index: 9999999 !important;
  "
></div>
<div class="siteHome">
  <div class="mainCon">
    <div class="leftCon">
      <div class="left_content">
        <img src="../../../assets/images/login_bg.png" class="leftConImage"alt="" />
        <!-- <h3 class="left_text" style="margin-top: 80px">
          Asset Health & Predictive
          <h3 style="color: #ffff;
          margin-top: 8px;
          position: relative;
          left: 88px;
          font-size: 32px;
          font-weight: 500;">Maintenance</h3>
          <hr  style="width:100%;text-align:left;margin-left:8px; margin-top: 0px;">
         </h3> -->
         
        <!-- <span class="login_desc"
          >Reduce unplanned downtime, Improve asset <br>
          <span style="color: #ffff;
          font-size: 20px;
          margin-top: 8px;
          position: absolute;
          left: 228px;">availability, and OLE</span>
      </span> -->
        <br />
        <br />
      </div>
    </div>
    <div class="rightCon" style="height: 140%;">
      <div class="login_card">
        <div class="imgcon">
          <img src="../../../assets/images/predict.ai logo.svg" style="height: 45px" />
        </div>

        <form
          [formGroup]="loginForm"
          (ngSubmit)="login(loginForm)"
          class="kt-form"
          autocomplete="nope"
        >
          <div class="inputcon"  *ngIf="checked=='email'">
            <label>Username</label>
            <input
              class="form-control"
              formControlName="useremail"
              id="username"
              placeholder="Username"
              type="text"
              autocomplete="off"
            />
            <div style="font-size: 10px;margin-top:10px;margin-right:10px">
              <i class="fas fa-info-circle"></i> Used for Login.
            </div>
            <div
              *ngIf="
                loginForm.get('useremail')?.touched &&
                loginForm.get('useremail')?.invalid
              "
              class="text-danger"
            >
              <div
                *ngIf="loginForm.get('useremail')?.errors?.required"
                class="errorTextInput"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" /> 
              Username is Required.
              </div>
              <div
                *ngIf="loginForm.get('useremail')?.errors?.email"
                class="errorTextInput"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" /> 
              Please Enter a Valid Email
              </div>
            </div>
          </div>
          <!-- <div class="userVerify" *ngIf="checked=='otpField'">
            <label class="labeledMail" style="font-size: 13px;
            text-align: -webkit-auto;
            font-weight: 600 ;">{{enteredEmail}}<i class="far fa-edit" style="padding-left:5px ;" (click)="checked='email'"></i>
            </label>
              <input type="text" class="form-control" placeholder="Enter OTP" formControlName="otpField" 
              class="w-80"  
              (cut)="$event.preventDefault()" (copy)="$event.preventDefault()" (paste)="$event.preventDefault()" />
              <div *ngIf="
              loginForm.get('otpField')?.touched || loginForm.get('otpField')?.invalid
            " class="text-danger">
              <div *ngIf="loginForm.get('otpField')?.errors?.required" class="errorTextInput">
                <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" /> 
                OTP is required.
              </div>
              <div *ngIf="loginForm.get('otpField')?.errors?.minlength" class="errorTextInput">
                <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" /> 
                OTP Should have 6 Characters
              </div>
            </div>
            <button
              class="btn btn-brand btn-pill btn-elevate"
              id="login_submit"
              type="submit"
              (click)="resendOtp(loginForm)"
            >
              Resend OTP
            </button>
            </div>
          <div class="inputcon" *ngIf="checked=='password'">
            <label>New Password</label>
            <input
            id="password"
            class="form-control"
            #password
            autocomplete="off"
            [type]="hide ? 'password' : 'text'"
            placeholder="New Password"
            formControlName="password"
            maxlength="40"
            minlength="8"
            (cut)="$event.preventDefault()" (copy)="$event.preventDefault()" (paste)="$event.preventDefault()">
            <mat-icon class="placeholder" (click)="passwordView()" class="password_view" >{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            <div
              *ngIf="
                loginForm.get('password')?.touched &&
                loginForm.get('password')?.invalid
              "
              class="text-danger"
            >
              <div
                *ngIf="loginForm.get('password')?.errors?.required"
                class="errorTextPawwsord"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" /> 
              Password is Required.
              </div>
              <div
                *ngIf="loginForm.get('password')?.errors?.minlength"
                class="errorTextPawwsord"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" /> 
              Must be at least 8 Characters!
              </div>
              <div
                *ngIf="loginForm.get('password')?.errors?.hasNumber"
                class="errorTextPawwsord"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" /> 
              Must contain at least 1 Number!
              </div>
              <div
                *ngIf="loginForm.get('password')?.errors?.hasCapitalCase"
                class="errorTextPawwsord"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" /> 
              Must contain at least 1 in Capital Case!
              </div>
              <div
                *ngIf="loginForm.get('password')?.errors?.hasLowerCase"
                class="errorTextPawwsord"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" />
               Must contain at least 1 in Lower Case!
              </div>
              <div
                *ngIf="loginForm.get('password')?.errors?.hasSpecialCharacters"
                class="errorTextPawwsord"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" />
               Must contain at least 1 in Special Character!
              </div>
            </div>
          </div>

          <div class="inputcon1" *ngIf="checked=='password'">
            <label>Confirm New Password</label>
            <input
            id="password"
            class="form-control"
            #password
            autocomplete="off"
            [type]="hide ? 'password' : 'text'"
            placeholder="Confirm Password"
            formControlName="confirmpassword"
            maxlength="40"
            minlength="8"
            (cut)="$event.preventDefault()" (copy)="$event.preventDefault()" (paste)="$event.preventDefault()">
            <mat-icon class="placeholder" (click)="passwordView()" class="password_view" >{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            <div
              *ngIf="
                loginForm.get('confirmpassword')?.touched &&
                loginForm.get('confirmpassword')?.invalid
              "
              class="text-danger"
            >
              <div
                *ngIf="loginForm.get('confirmpassword')?.errors?.required"
                class="errorTextPawwsord"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" />
               Confirmpassword is Required.
              </div>
              <div
                *ngIf="loginForm.get('confirmpassword')?.errors?.notEquivalent"
                class="errorTextPawwsord"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" />
               Password does not match.
              </div>
            </div>
          </div> -->

          <div class="login_right_actions">
            <button
              *ngIf="checked=='email' || checked=='otpField'"
              [disabled]="loginForm.get('useremail')?.invalid"
              class="btn btn-brand btn-pill btn-elevate"
              id="login_submit"
              type="submit"
            >
              Submit
            </button>
            <!-- <button
              *ngIf="checked=='password'"
              class="btn btn-brand btn-pill btn-elevate submit"
              id="login_submit"
              type="submit"
              [disabled]="!loginForm.valid"
            >
              Update
            </button> -->
            <div style="padding-top: 15px">
              <!-- <a class="" > Sign In</a> -->
              <button
              *ngIf="!checked"
              class="btn btn-brand btn-pill btn-elevate signin"
              routerLink="/login"
              id="login_submit"
              type="submit"
            >
              Sign In
            </button>
            </div>
            <div style="padding-bottom: 10px; padding-top: -2px; ">
              <button
              *ngIf="checked"
              class="btn btn-brand btn-pill btn-elevate signin"
              routerLink="/login"
              id="login_submit"
              type="submit"
            >
              Sign In
            </button>
            </div>
          </div>
          <p style="position: relative; top: 25px; right: 25px">
            <a class="cursor-pointer">Copyright</a> <span class="copyright">@ 2023 BLP Industry.AI. All
              rights reserved</span>
            </p>
        </form>
      </div>
    </div>
  </div>
</div>
